import * as i0 from '@angular/core';
import { input, booleanAttribute, computed, Component, NgModule } from '@angular/core';
let BrnSeparatorComponent = /*#__PURE__*/(() => {
  class BrnSeparatorComponent {
    orientation = input('horizontal');
    decorative = input(false, {
      transform: booleanAttribute
    });
    role = computed(() => this.decorative() ? 'none' : 'separator');
    ariaOrientation = computed(() => this.decorative() ? undefined : this.orientation() === 'vertical' ? 'vertical' : undefined);
    /** @nocollapse */
    static ɵfac = function BrnSeparatorComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BrnSeparatorComponent)();
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BrnSeparatorComponent,
      selectors: [["brn-separator"]],
      hostVars: 3,
      hostBindings: function BrnSeparatorComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵhostProperty("role", ctx.role());
          i0.ɵɵattribute("aria-orientation", ctx.ariaOrientation())("data-orientation", ctx.orientation());
        }
      },
      inputs: {
        orientation: [1, "orientation"],
        decorative: [1, "decorative"]
      },
      decls: 0,
      vars: 0,
      template: function BrnSeparatorComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return BrnSeparatorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BrnSeparatorModule = /*#__PURE__*/(() => {
  class BrnSeparatorModule {
    /** @nocollapse */static ɵfac = function BrnSeparatorModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BrnSeparatorModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: BrnSeparatorModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return BrnSeparatorModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { BrnSeparatorComponent, BrnSeparatorModule };
